import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import * as _ from 'lodash';
import { ICategoria } from '../../../../model/interface/ICategoria';

@Component({
  selector: 'app-especiales-sf',
  templateUrl: './especiales-sf.component.html',
  styles: []
})
export class EspecialesSfComponent implements OnInit {

  categorias: ICategoria[];
  categoriasMostradas: ICategoria[];
  ordenCategorias: any;
  filTipo: any;
  filTemporada: any;
  listOrden: any[];
  listTipos: any[];
  listTemporadas: any[];

  constructor(
    private _categoriaService: CategoriaService
  ) {
    this.categorias = [];
    this.categoriasMostradas = [];

    this.listOrden = [
      { value: 'masRecientes', label: 'Más Recientes' },
      { value: 'masAntiguas', label: 'Más Antiguas' }
    ];

    this.listTipos = [
      { value: 'todos', label: 'Todos' }
    ];

    this.listTemporadas = [
      { value: 'todos', label: 'Todos' },
      { value: 'primavera', label: 'Primavera' },
      { value: 'verano', label: 'Verano' },
      { value: 'otono', label: 'Otoño' },
      { value: 'invierno', label: 'Invierno' },
    ];

    this.ordenCategorias = this.listOrden[0].value;
    this.filTipo = this.listTipos[0].value;
    this.filTemporada = this.listTemporadas[0].value;
  }

  ngOnInit() {

    this._categoriaService.getDeFantasia()
      .subscribe( data => {
        this.categorias = data;
        this.categoriasMostradas = data;
        this.ordenarCategorias();
      });
  }


  ordenarCategorias(model?: string) {

    if (model) {
      this.ordenCategorias = model;
    }

    switch (this.ordenCategorias) {
      case 'masRecientes': {
        this.categoriasMostradas = _.orderBy(this.categoriasMostradas, (o: any) => {
          return o.fecCreacion;
        }, 'desc');
        break;
      }
      case 'masAntiguas': {
        this.categoriasMostradas = _.orderBy(this.categoriasMostradas, (o: any) => {
          return o.fecCreacion;
        });
        break;
      }
    }
  }

  filtrarPorTipo(model?: string) {
    if (model) {
      this.filTipo = model;
    }
  }

  filtrarPorTemporada(model?: string) {
    if (model) {
      this.filTemporada = model;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/especiales-sf/especiales-sf.component.ts